import { Helmet, HelmetProvider } from "react-helmet-async"
import { Outlet } from "@tanstack/react-router"

import ogImage from "#/assets/mezo-landing-ogimage.png"
import {
  useBeforeUnload,
  useBorrowData,
  useDAppRoute,
  usePortal,
  useSentry,
  useWallet,
} from "#/shared/hooks"
import AppContainer from "#/ui-old/AppContainer"
import ErrorWrapper from "#/ui-old/ErrorWrapper"
import MezoModal from "#/ui-old/Modal"

export default function App() {
  const isDAppRoute = useDAppRoute()

  useSentry()
  useWallet()
  usePortal()
  useBorrowData()
  useBeforeUnload()

  if (!isDAppRoute) {
    return <Outlet />
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta property="og:image" content={`https://mezo.org${ogImage}`} />
        </Helmet>
      </HelmetProvider>
      <ErrorWrapper>
        <AppContainer />
        <MezoModal />
      </ErrorWrapper>
    </>
  )
}
